import {
  SocialConfigActionTypes,
  ISocialPlatform,
  SocialConfigState,
  ISocialBase,
} from 'interfaces'

type Action =
  | { type: SocialConfigActionTypes.SET_SOCIAL; payload: ISocialBase }
  | { type: SocialConfigActionTypes.REMOVE_SOCIAL; payload: ISocialPlatform }
  | { type: SocialConfigActionTypes.SET_ERROR; payload: string }
  | { type: SocialConfigActionTypes.SET_IS_CONFIGURING; payload: boolean }
  | {
      type: SocialConfigActionTypes.SET_CONFIGURING_SOCIAL
      payload: ISocialBase
    }
  | { type: SocialConfigActionTypes.SET_SOCIALS; payload: ISocialBase[] }
  | { type: SocialConfigActionTypes.SET_ALERT_EMPTY_SOCIALS; payload: boolean }
  | { type: SocialConfigActionTypes.SET_LOADING; payload: boolean }

export const socialConfigReducer = (
  state: SocialConfigState,
  action: Action
) => {
  switch (action.type) {
    case SocialConfigActionTypes.SET_IS_CONFIGURING:
      return { ...state, isConfiguring: action.payload }

    case SocialConfigActionTypes.SET_CONFIGURING_SOCIAL:
      return { ...state, configuringSocial: action.payload }

    case SocialConfigActionTypes.SET_SOCIAL:
      return {
        ...state,
        socials: state.socials.map((social) =>
          social.platform === action.payload.platform ? action.payload : social
        ),
      }
    case SocialConfigActionTypes.REMOVE_SOCIAL:
      return {
        ...state,
        socials: state.socials.map((social) =>
          social.platform === action.payload
            ? { ...social, identifier: '', audience: 0, isConfigured: false }
            : social
        ),
      }

    case SocialConfigActionTypes.SET_SOCIALS:
      return { ...state, socials: action.payload }

    case SocialConfigActionTypes.SET_ERROR:
      return { ...state, error: action.payload }

    case SocialConfigActionTypes.SET_ALERT_EMPTY_SOCIALS:
      return { ...state, alertEmptySocials: action.payload }

    case SocialConfigActionTypes.SET_LOADING:
      return { ...state, loading: action.payload }

    default:
      return state
  }
}
